"use strict";
exports.__esModule = true;
exports["default"] = {
    DEFAULT_CONTENT_DIVIDER: 'default',
    DEFAULT_DATE_FORMAT: 'dd.MM.yyyy',
    DEFAULT_TIME_FORMAT: 'HH:mm'
};
